
export interface DirectDataInputSearchCriteria {
    masterType: string | null,
    opsDateFrom: Date | null,
    opsDateTo: Date | null,
    forwarderCode: string | null,
    truckerName: string | null,
    cnicNo: string | null,
    vehicleNo: string | null,
    damageType: string | null,
    status: string | null,
    createdDateFrom: Date | null,
    createdDateTo: Date | null,


    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_DIRECT_DATA_INPUT_SEARCH_CRITERIA: DirectDataInputSearchCriteria = {
    masterType: null,
    opsDateFrom: null,
    opsDateTo: null,
    forwarderCode: null,
    truckerName: null,
    cnicNo: null,
    vehicleNo: null,
    damageType: null,
    status: null,
    createdDateFrom: null,
    createdDateTo: null
}